// removed by extract-text-webpack-plugin
module.exports = {"listing":"_390gt _1rpGL _2qntr Kv265 _3TEYy","undo":"WmExC _1sS2g _2Eplg W_-nV _19fGQ _2zPYc _1Q5o6 _1-OXK _3Xg8b","actions":"_3DR3C _1-OXK _3Xg8b _2irZW","undoButton":"_24SAQ LPShn _3q_uq _1v96X","dismissButton":"_1dv1M _1wqBz"};


//////////////////
// WEBPACK FOOTER
// ./containers/UndoListing.css
// module id = 1980
// module chunks = 3